'use client'
import { __awaiter } from '../../_virtual/_tslib.js';
import { createWalletClient, custom } from 'viem';
import { Wallet } from '@dynamic-labs/wallet-connector-core';
import '@dynamic-labs/utils';
import '../utils/logger.js';
import '../utils/viem/estimateL1Fee/opStack/estimateL1Fee.js';
import '../utils/viem/chainsMap/chainsMap.js';
import { interceptTransport } from '../utils/viem/interceptTransport/interceptTransport.js';
import 'viem/accounts';
import 'viem/chains';

class EthereumWallet extends Wallet {
    /**
     * Retrieves the public client.
     * @returns A promise that resolves to the public client,
     * or throws if the client cannot be retrieved.
     */
    getPublicClient() {
        return __awaiter(this, void 0, void 0, function* () {
            const client = yield this._connector.getPublicClient();
            if (!client) {
                throw new Error('Unable to retrieve PublicClient');
            }
            return client;
        });
    }
    /**
     * Retrieves the wallet client.
     * @param chainId - (optional) Chain id to be used by the wallet client.
     * @returns A promise that resolves to the wallet client,
     * or throws if the client cannot be retrieved.
     */
    getWalletClient(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const walletClient = this._connector.getWalletClient(chainId);
            if (!walletClient) {
                throw new Error('Unable to retrieve WalletClient');
            }
            return createWalletClient({
                account: this.address,
                chain: walletClient.chain,
                transport: interceptTransport({
                    onPersonalSign: (_a) => __awaiter(this, [_a], void 0, function* ({ provider, args }) {
                        yield this.sync();
                        return provider.request(args);
                    }),
                    onSendTransaction: (_b) => __awaiter(this, [_b], void 0, function* ({ provider, args }) {
                        yield this.sync();
                        return provider.request(args);
                    }),
                    onSignTypedData: (_c) => __awaiter(this, [_c], void 0, function* ({ provider, args }) {
                        yield this.sync();
                        return provider.request(args);
                    }),
                    transport: custom(walletClient.transport),
                }),
            });
        });
    }
}

export { EthereumWallet };
